module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-update-platform/master-update-platform.component.scss
// module id = ./src/app/master/master-update-platform/master-update-platform.component.scss
// module chunks = main